import * as yup from 'yup'

export const NewMessageSchema = yup.object().shape({
  content: yup.string().trim().required('invalidInput'),
})
